import { Typography } from '@mui/material';
import React from 'react';
import {
    CUSTOMER_CATEGORY_COLORS,
    formatCustomerDisplayName,
    isHighlightedCustomerCategory,
    normalizeCustomerCategory,
} from '../helpers/customers';

/**
 * Nome do cliente com prefixo de categoria quando não for "Cliente".
 * Destaca Parceiro / Vendedor / Afiliado com cores distintas.
 */
function CustomerDisplayName({ customer, name, category, fallback = 'N/A', variant = 'body2', sx, ...props }) {
    const resolved = customer || { name, category };
    const resolvedCategory = normalizeCustomerCategory(resolved?.category ?? category);
    const label = formatCustomerDisplayName(resolved, resolvedCategory);
    const display = label === '—' ? fallback : label;
    const highlighted = isHighlightedCustomerCategory(resolvedCategory);
    const colorConfig = CUSTOMER_CATEGORY_COLORS[resolvedCategory];

    if (!highlighted) {
        return (
            <Typography variant={variant} component="span" sx={sx} {...props}>
                {display}
            </Typography>
        );
    }

    return (
        <Typography
            variant={variant}
            component="span"
            fontWeight={600}
            sx={{
                display: 'inline-block',
                px: 0.75,
                py: 0.25,
                borderRadius: 1,
                ...colorConfig?.sx,
                ...sx,
            }}
            {...props}
        >
            {display}
        </Typography>
    );
}

export default CustomerDisplayName;
